import { Modal } from "antd";
import Button from "Components/Button";
import Textarea from "Components/Textarea";
import { OrderDetails, useOrder } from "hooks/OrderManagement/useOrders";
import { useBoolean } from "hooks/useBoolean";
import { useState } from "react";

type DeclineOrderProps = {
  data: OrderDetails;
};
export const DeclineOrder = ({ data }: DeclineOrderProps) => {
  const [declineModal, setDeclineModal] = useBoolean(false);
  const { refetch, cancelOrderLoading, cancelOrderMutation } = useOrder(
    data?.id
  );
  const [declineReason, setDeclineReason] = useState("");

  return (
    <div>
      <Button
        label="Decline Order"
        onClick={setDeclineModal.on}
        className="bg-[#E8E8E8] text-black"
      />
      <Modal
        open={declineModal}
        onCancel={setDeclineModal.off}
        footer={null}
        title="Decline Order">
        <div className="text-center grid gap-y-4 py-2">
          <p className="text-primary-foreground text-lg">
            Are you sure you want to cancel this order, this action can not be
            reversed
          </p>

          <div className="">
            <Textarea
              placeholder="Reason for declining"
              name="reason_for_declining"
              value={declineReason}
              onChange={(e) => setDeclineReason(e.target.value)}
            />
          </div>

          <div className="flex space-x-2">
            <Button
              label="Yes"
              isLoading={cancelOrderLoading}
              onClick={() => {
                cancelOrderMutation(
                  { reason: declineReason },
                  {
                    onSuccess: () => {
                      refetch();
                      setDeclineReason("");
                      setDeclineModal.off();
                    },
                  }
                );
              }}
            />
            <Button
              label="No"
              onClick={setDeclineModal.off}
              className="bg-[#E8E8E8] text-[#2E2E2E]"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
